module.exports = __webpack_public_path__ + "static/media/lease1_img3.c97b7aec.jpg";